import React from 'react';
const MenuContext = React.createContext();

export default MenuContext;
export const MenuContextProvider = MenuContext.Provider;
export const MenuContextConsumer = MenuContext.Consumer;